// extracted by mini-css-extract-plugin
export default {"root":"CenterOnStationButton_root__Pr5Oh","button":"CenterOnStationButton_button__KvJdo","icon":"CenterOnStationButton_icon__lcE1X"};